import '../sass/latest-news.scss';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const swiperScript = document.querySelector('#boomspace-theme-swiper-js');
    const $blocks = document.querySelectorAll('.latest-news');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $slider = $block.querySelector('.latest-news__carousel');

        const initCarousel = () => {
            if (!$slider) return;

            new Swiper($slider, {
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                spaceBetween: 20,
                pagination: {
                    el: '.latest-news__pagination',
                    clickable: true
                },
                speed: noMotionPreference.matches ? 300 : 0,
            });
        };

        if (typeof Swiper !== 'undefined') { 
            initCarousel();
        } else {
            swiperScript.addEventListener('load', () => {
                initCarousel();
            });
        }
    });
})();
